import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=a3fc08d2&scoped=true&"
import script from "./HeaderComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=a3fc08d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fc08d2",
  null
  
)

export default component.exports